import React from "react";
import { Link } from "react-router-dom";
import { disclaimer, links } from "../../../config/ptemax/site";

const columns = [
  {
    heading: "STUDENTS",
    items: [
      // { label: "Free mock test", href: "/ptemax/free-pte-mock-test" },
      { label: "The platform", href: "/ptemax/platform" },
      { label: "Pricing", href: "/ptemax/pricing" },
      { label: "Sign in", href: links.signIn, external: true },
    ],
  },
  {
    heading: "LEARN",
    items: [
      { label: "PTE exam pattern 2026", href: "/ptemax/pte-exam-pattern-2026" },
      { label: "Score requirements", href: "/ptemax/pte-score-requirements" },
      { label: "Score calculator", href: "/ptemax/pte-score-calculator" },
      { label: "PTE to IELTS converter", href: "/ptemax/pte-to-ielts-converter" },
      { label: "Exam fees by country", href: "/ptemax/pte-exam-fees" },
      { label: "Compare platforms", href: "/ptemax/pte-vs" },
    ],
  },
  {
    heading: "INSTITUTES",
    items: [
      { label: "White-label platform", href: "/ptemax/institutes" },
      { label: "Request a demo", href: links.instituteDemo, external: true },
    ],
  },
  {
    heading: "COMPANY",
    items: [
      { label: "About", href: "/ptemax/about" },
      { label: "Contact support", href: "/contact"},
      // { label: "Contact support", href: "mailto:support@ptemax.com", external: true },
      { label: "Privacy", href: "/ptemax/privacy" },
      { label: "Terms", href: "/ptemax/terms" },
      { label: "Refund policy", href: "/ptemax/refund-policy" },
    ],
  },
];

export default function PteMaxFooter() {
  return (
    <footer style={{ borderTop: "1px solid #22383c", background: "#0c181c" }}>
      <div className="container py-5">
        <div className="row g-5">
          {/* Logo + description */}
          <div className="col-lg-3">
            <div className="d-flex align-items-center gap-2">
              <svg width="24" height="24" viewBox="0 0 32 32" fill="none">
                <circle cx="16" cy="16" r="14" stroke="#5fd3c6" strokeWidth="2.5" />
                <circle cx="16" cy="16" r="4" fill="#5fd3c6" />
              </svg>
              <span className="fw-bold" style={{ color: "#ecf3f1", fontFamily: "'Sora', sans-serif" }}>
                PTE<span style={{ color: "#5fd3c6" }}>Max</span>
              </span>
            </div>
            <p className="mt-3 small lh-lg" style={{ color: "#7d928e" }}>
              AI-scored PTE practice for students worldwide, and the white-label platform training institutes run on.
            </p>
          </div>

          {/* Link columns */}
          <div className="col-lg-9">
            <div className="row row-cols-2 row-cols-sm-4 g-4">
              {columns.map((col) => (
                <div key={col.heading} className="col">
                  <h3 className="small fw-semibold text-uppercase" style={{ color: "#b2c4c1", letterSpacing: "0.1em", fontSize: "0.7rem" }}>
                    {col.heading}
                  </h3>
                  <ul className="list-unstyled mt-3 d-flex flex-column gap-2">
                    {col.items.map((item) =>
                      item.external ? (
                        <li key={item.label}>
                          <a href={item.href} className="text-decoration-none small" style={{ color: "#7d928e" }}>
                            {item.label}
                          </a>
                        </li>
                      ) : (
                        <li key={item.label}>
                          <Link to={item.href} className="text-decoration-none small" style={{ color: "#7d928e" }}>
                            {item.label}
                          </Link>
                        </li>
                      )
                    )}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-5 pt-4" style={{ borderTop: "1px solid #22383c" }}>
          <p className="small lh-lg" style={{ color: "#7d928e" }}>{disclaimer}</p>
          <p className="mt-2 small" style={{ color: "#728683" }}>
            © {new Date().getFullYear()} PTEMax. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
